import { renderTwigReactComponent } from 'Modules/dom';
import Error410 from './Error410';

function initErrorPage() {
  renderTwigReactComponent('error410', Error410, { useRedux: true });
}

export default initErrorPage;
